module.exports = __webpack_public_path__ + "img/note9.9545a4c3.png";